var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "hkl-gray-hint",
      class: _vm.fontSize ? "font-size-" + _vm.fontSize : "",
    },
    [
      _vm.hint ? [_vm._v("\n    " + _vm._s(_vm.hint) + "\n  ")] : _vm._e(),
      _vm._v(" "),
      !_vm.hint ? _vm._t("default") : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }